import React, {Component} from "react";
import { Input } from 'antd';
import { Row, Col, Button } from 'antd';

import apiCodeforces from "../assets/js/apiCodeforces";

const { Search } = Input;

export default class UserSearch extends Component {
	state = {
		isSearching: false
	}

	userHandle = "";

	render() {
		return (
			<div className="UserSearch">
				<Row type="flex" align="middle" justify="center">
					<Col sm={ { span: 16 } } md={ { span: 12 } } lg={ { span: 10 } }>
						<Search
							name="user-handle" placeholder="User handle"
							className="UserSearch__input"
							onChange={ e => this.userHandle = e.target.value }
						/>
					</Col>
				</Row>

				<Row type="flex" align="middle" justify="center" style={ { marginTop: "1rem" } }>
					<Col sm={ { span: 16 } } md={ { span: 12 } } lg={ { span: 6 } } style={ { textAlign: "center" } }>
						<Button type="primary" icon="search" size="large" loading={ this.state.isSearching } onClick={ this.search }>
							Search user
						</Button>
					</Col>
				</Row>
			</div>
		);
	}

	search = async () => {
		this.setState({
			isSearching: true
		});

		await this.searchUser(this.userHandle);
		
		this.setState({
			isSearching: false
		});
	}

	searchUser = async userHandle => {
		console.clear();
		
		userHandle = userHandle.trim();
		if (userHandle.length > 0) {

			try {
				const userInfo = await apiCodeforces.getUserInfo(userHandle);
				
				if (userInfo.handle)
					this.props.onSearch(userInfo);
			}
			catch (err) {
				console.clear();
				this.props.onSearch({ errorHandle: true })
			}
		}
	}
}